import { z } from "zod";

export const vehiclesStatusCountItemSchema = z.object({
  companyUuid: z.uuid(),
  activeVehiclesCount: z.number(),
  activeConnectedVehiclesCount: z.number(),
});

export type VehiclesStatusCountItem = z.infer<
  typeof vehiclesStatusCountItemSchema
>;

export const getVehiclesStatusCountListResponseSchema = z.array(
  vehiclesStatusCountItemSchema,
);

export type GetVehiclesStatusCountListResponse = z.infer<
  typeof getVehiclesStatusCountListResponseSchema
>;
